
export const USER_REPORTS = 'admin/user/reportedUsers';
export const DELETE_REPORTS = 'admin/user/report';



